import { useState, useEffect, useRef } from "react";

import Style from "./style";
import addIcon from "./asset/add.svg";
import eraseIcon from "./asset/erase.svg";
import upperIcon from "./asset/upper.svg";
import downIcon from "./asset/down.svg";
import EventModal from "./ui/EventModal";
import EventModalManager from "./ui/EventModalManager";
import SeriesModal from "./ui/SeriesModal";
import usePrizeEvent from "./model/usePrizeEvent";
import useDurationEvent from "./model/useDurationEvent";
import useReEntryChipEvent from "./model/useReEntryChipEvent";

import MainHeader from "widget/MainHeader";

import usePostImgListUpload from "entity/util/usePostImgListUpload";
import useGetSeedTicketTypeList from "entity/series/useGetSeedTicketTypeList";
import usePostEvent from "entity/event/usePostEvent";
import usePostImgUpload from "entity/util/usePostImgUpload";
import useGetMyFranchise from "entity/franchise/useGetMyFranchise";

import CStyle from "shared/style/commonStyle";
import ITStyle from "shared/style/inputTableStyle";
import DefaultButton from "shared/ui/DefaultButton";
import timestampCalculator from "shared/lib/timestampCalculator";
import {
  OFFICIAL,
  PRELIMINARY,
  STORE,
  TRYOUT,
  FREEROLL,
} from "shared/constant/lookup/eventType";
import {
  ROLE_FRANCHISE_MANAGER,
  ROLE_STORE_MANAGER,
} from "shared/constant/lookup/role";
import useRoleCookie from "shared/model/useRoleCookie";
import { datetimeLocalValueCalculator } from "shared/lib/datetimeLocalCalculator";
import { handleNumbersOnly, handleTextOnly } from "shared/lib/inputValidation";

const EventCreate = () => {
  const nameRef = useRef();
  const eventTypeRef = useRef();
  const [eventTypeFlag, setEventTypeFlag] = useState(null);
  const addressRef = useRef();
  const dateRef = useRef();
  const regDateRef = useRef();
  const proGradeRef = useRef();
  const [requiredProGradeFlag, setRequiredProGradeFlag] = useState(null);
  const contentRef = useRef();
  const imgInputRef = useRef();
  const posterInputRef = useRef();
  const [sereisData, setSeriesData] = useState();
  const startingChipRef = useRef();
  const regEndLevelRef = useRef();
  const earlyEndLevelRef = useRef();
  const earlyChipRef = useRef();
  const maxEntryRef = useRef();
  const reEntryRef = useRef();
  const addOnRef = useRef();
  const addOnChipRef = useRef();
  const prizeTotalRef = useRef();
  const seeTicketTypeRef = useRef();
  const [seedTicketTypeIdx, setSeedTicketTypeIdx] = useState(null);
  const ticketNumberRef = useRef();
  const publishedTicketNumberRef = useRef();
  const storeRef = useRef();
  const [manager_idx, setSelectedStoreIdx] = useState(null);

  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [isSeriesModalOpen, setIsSeriesModalOpen] = useState(false);

  const [eventData, setEventData] = useState(null);
  const [
    prizeList,
    setPrize,
    createPrizeEvent,
    deletePrizeEvent,
    upperPrizeEvent,
    downPrizeEvent,
  ] = usePrizeEvent(eventData?.prize_list);
  const [
    durationList,
    setDuration,
    createDurationEvent,
    createBreakEvent,
    deleteDurationEvent,
    upperDurationEvent,
    downDurationEvent,
  ] = useDurationEvent(eventData?.duration_list);
  const [
    reEntryList,
    changeReEntryChipEvent,
    incReEntryChipEvent,
    deleteReEntryEvent,
  ] = useReEntryChipEvent(eventData?.re_entry_chip);
  const [seedTicketTypeList] = useGetSeedTicketTypeList(sereisData?.idx);
  const [posterFilePath, uploadPosterEvent, deletePosterImg] = usePostImgUpload(
    eventData?.poster_img
  );
  const [imgPathList, uploadImgEvent, deleteImg] = usePostImgListUpload(
    eventData?.img_list,
    10
  );
  const [postEvent] = usePostEvent(
    nameRef,
    eventTypeFlag,
    addressRef,
    dateRef,
    regDateRef,
    requiredProGradeFlag,
    contentRef,
    imgPathList,
    posterFilePath,
    sereisData?.idx,
    startingChipRef,
    regEndLevelRef,
    earlyEndLevelRef,
    earlyChipRef,
    maxEntryRef,
    reEntryRef,
    reEntryList,
    addOnRef,
    addOnChipRef,
    prizeTotalRef,
    seedTicketTypeIdx,
    ticketNumberRef,
    publishedTicketNumberRef,
    prizeList,
    durationList,
    manager_idx
  );

  const [roleCookie] = useRoleCookie();
  const isManager = [ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER].includes(
    roleCookie
  );
  const [myFranchiseData] = useGetMyFranchise();

  // 다른 대회 불러오기 요청 후, 대회 종류 Select와 Series 데이터 삽입
  useEffect(() => {
    // 대회 정보 통신 후 실행
    if (eventData) {
      console.log(eventData);
      if (eventTypeRef.current) {
        eventTypeRef.current.value = eventData?.event_type_flag;
        setEventTypeFlag(eventData?.event_type_flag);
      }
      setSeriesData({
        idx: eventData?.series_idx,
        start_date: eventData?.series_start_date,
        end_date: eventData?.series_end_date,
        name: eventData?.series_name,
      });
    }
  }, [eventData]);

  // 요구 프로 자격 Select 삽입
  useEffect(() => {
    if (eventTypeFlag) {
      // 대회 종류가 삽입되었을 때 실행해야 버그 없음
      if (proGradeRef.current) {
        proGradeRef.current.value = eventData?.pro_grade_flag;
        setRequiredProGradeFlag(eventData?.pro_grade_flag);
      }
    }
  }, [eventTypeFlag]);

  // 시드권 종류 목록 요청 후, 시드권 종류 Select 데이터 삽입
  useEffect(() => {
    if (seedTicketTypeList) {
      if (seeTicketTypeRef.current) {
        seeTicketTypeRef.current.value = `${eventData?.seed_ticket_type_idx}`;
        setSeedTicketTypeIdx(eventData?.seed_ticket_type_idx);
      }
    }
  }, [seedTicketTypeList]);

  const btnList = [
    {
      label: "다른 대회 불러오기",
      clickEvent: () => setIsEventModalOpen(true),
    },
    {
      label: "생성",
      clickEvent: () => postEvent(),
    },
  ];
  const adminEventTypeList = [
    {
      flag: 1,
      name: "공식 대회",
    },
    {
      flag: 4,
      name: "트라이아웃 대회",
    },
    {
      flag: 5,
      name: "프리롤 대회",
    },
  ];
  const managerEventTypeList = [
    {
      flag: 2,
      name: "공식 예선전 대회",
    },
    {
      flag: 3,
      name: "매장 대회",
    },
  ];
  const eventTypeList = isManager ? managerEventTypeList : adminEventTypeList;
  const proGradeList = [
    {
      flag: 1,
      name: "없음",
    },
    {
      flag: 3,
      name: "Rookie",
    },
    {
      flag: 5,
      name: "Semi",
    },
    {
      flag: 7,
      name: "Tour",
    },
  ];
  const tryoutProGradeList = [
    {
      flag: 2,
      name: "Basic Rookie",
    },
    {
      flag: 4,
      name: "Basic Semi",
    },
    {
      flag: 6,
      name: "Basic Tour",
    },
  ];

  // 대회 종류 Select 변경 이벤트
  const changeEventTypeEvent = (e) => {
    setEventTypeFlag(parseInt(e.target.value));
    setRequiredProGradeFlag(null); // 대회 종류 변경시, 요구 프로자격 초기화
    proGradeRef.current.value = "init"; // 대회 종류 변경시, select 초기화
  };

  // 요구 프로 자격 Selet 변경 이벤트
  const changeRequiredProGradeEvent = (e) => {
    setRequiredProGradeFlag(parseInt(e.target.value));
  };

  // 시드권 종류 Select 변경 이벤트
  const changeSeedTicketTypeEvent = (e) => {
    setSeedTicketTypeIdx(e.target.value);
  };

  // 매장 선택 변경 이벤트
  const changeStoreEvent = (e) => {
    if (roleCookie === ROLE_FRANCHISE_MANAGER) {
      setSelectedStoreIdx(parseInt(e.target.value));
    }
  };

  let levelIndex = 0;

  return (
    <>
      {isEventModalOpen && !isManager && (
        <EventModal
          closeEvent={() => setIsEventModalOpen(false)}
          setEventData={setEventData}
        />
      )}
      {isEventModalOpen && isManager && (
        <EventModalManager
          closeEvent={() => setIsEventModalOpen(false)}
          setEventData={setEventData}
        />
      )}
      {isSeriesModalOpen && (
        <SeriesModal
          closeEvent={() => setIsSeriesModalOpen(false)}
          setSeriesData={setSeriesData}
        />
      )}

      <Style.Wrapper>
        <MainHeader btnList={btnList} />

        {/* 대회 정보 입력 */}
        <ITStyle.TableDiv>
          <ITStyle.TableVerticalElement>
            <h2>
              대회 이름<span>*</span>
            </h2>
            <input
              ref={nameRef}
              placeholder="40글자 이하"
              defaultValue={eventData?.name}
            />
          </ITStyle.TableVerticalElement>
          {[OFFICIAL, TRYOUT, FREEROLL].includes(eventTypeFlag) && (
            <ITStyle.TableVerticalElement>
              <h2>
                대회 주소지<span>*</span>
              </h2>
              <input ref={addressRef} defaultValue={eventData?.address} />
            </ITStyle.TableVerticalElement>
          )}
          <ITStyle.TableElement>
            <h2>
              대회 종류<span>*</span>
            </h2>
            <select ref={eventTypeRef} onChange={changeEventTypeEvent}>
              <option>== 선택 ==</option>
              {eventTypeList?.map((elem) => (
                <option value={elem?.flag}>{elem?.name}</option>
              ))}
            </select>
          </ITStyle.TableElement>
          <ITStyle.TableElement>
            <h2>
              요구 프로 자격<span>*</span>
            </h2>
            <select ref={proGradeRef} onChange={changeRequiredProGradeEvent}>
              <option value="init">== 선택 ==</option>
              {eventTypeFlag === TRYOUT
                ? tryoutProGradeList?.map((elem) => (
                    <option value={elem?.flag}>{elem?.name}</option>
                  ))
                : proGradeList?.map((elem) => (
                    <option value={elem?.flag}>{elem?.name}</option>
                  ))}
            </select>
          </ITStyle.TableElement>

          <ITStyle.TableElement>
            <h2>
              접수 시간<span>*</span>
            </h2>
            <input
              type="datetime-local"
              ref={regDateRef}
              defaultValue={datetimeLocalValueCalculator(eventData?.reg_date)}
            />
          </ITStyle.TableElement>
          <ITStyle.TableElement>
            <h2>
              대회 시간<span>*</span>
            </h2>
            <input
              type="datetime-local"
              ref={dateRef}
              defaultValue={datetimeLocalValueCalculator(eventData?.date)}
            />
          </ITStyle.TableElement>
          {roleCookie === ROLE_FRANCHISE_MANAGER && (
            <ITStyle.TableElement>
              <h2>
                매장 선택<span>*</span>
              </h2>
              <select ref={storeRef} onChange={changeStoreEvent}>
                <option value="">== 선택 ==</option>
                {myFranchiseData?.data?.store_list?.map((elem) => (
                  <option value={elem?.idx}>{elem?.store_name}</option>
                ))}
              </select>
            </ITStyle.TableElement>
          )}
          <ITStyle.TableVerticalElement>
            <h2>
              본문<span>*</span>
            </h2>
            <textarea ref={contentRef} defaultValue={eventData?.content} />
          </ITStyle.TableVerticalElement>
        </ITStyle.TableDiv>

        {/* 대회 포스터 이미지 첨부 */}
        <Style.AreaDiv>
          <h2>대회 포스터 이미지</h2>
          <CStyle.GuideDiv>
            <p>jpg, png 이미지 | 각 20mb 제한</p>
            <p>
              9:16 비율의 이미지에 가장 최적화 되어 있습니다만, 세로로 긴
              이미지라면 크게 상관 없습니다.
            </p>
          </CStyle.GuideDiv>
          <DefaultButton
            small
            fitWidth
            clickEvent={() => posterInputRef.current.click()}
          >
            첨부하기
          </DefaultButton>
          <input
            type="file"
            ref={posterInputRef}
            onChange={uploadPosterEvent}
            style={{ display: "none" }}
          />

          {posterFilePath && (
            <Style.ImgUploadDiv>
              <Style.ImgElement>
                <button onClick={deletePosterImg}>삭제</button>
                <img
                  src={posterFilePath}
                  onClick={() => window.open(posterFilePath, "_blank")}
                />
              </Style.ImgElement>
            </Style.ImgUploadDiv>
          )}
        </Style.AreaDiv>

        {/* 대회 이미지 첨부 */}
        <Style.AreaDiv>
          <h2> 이미지 첨부</h2>
          <CStyle.GuideDiv>
            <p>jpg, png 이미지 | 각 20mb 제한 | 최대 10개 까지 첨부</p>
            <p>16:9 비율의 이미지에 가장 최적화 되어 있습니다.</p>
          </CStyle.GuideDiv>
          <DefaultButton
            small
            fitWidth
            clickEvent={() => imgInputRef.current.click()}
          >
            첨부하기
          </DefaultButton>
          <input
            type="file"
            ref={imgInputRef}
            onChange={uploadImgEvent}
            style={{ display: "none" }}
          />

          {imgPathList.length > 0 && (
            <Style.ImgUploadDiv>
              {imgPathList?.map((elem, index) => (
                <Style.ImgElement>
                  <button onClick={() => deleteImg(index)}>삭제</button>
                  <img src={elem} onClick={() => window.open(elem, "_blank")} />
                </Style.ImgElement>
              ))}
            </Style.ImgUploadDiv>
          )}
        </Style.AreaDiv>

        {/* 시리즈 정보 입력 */}
        {[OFFICIAL, PRELIMINARY].includes(eventTypeFlag) && (
          <Style.AreaDiv>
            <Style.AreaHeader>
              <h2>
                대회 시리즈 선택<span>*</span>
              </h2>
              <DefaultButton
                small
                fitWidth
                clickEvent={() => setIsSeriesModalOpen(true)}
              >
                대회 시리즈 검색
              </DefaultButton>
            </Style.AreaHeader>
            {sereisData && (
              <Style.SeriesDataDiv>
                <p>대회 시리즈 IDX : {sereisData?.idx}</p>
                <p>대회 시리즈 이름 : {sereisData?.name}</p>
                <p>
                  대회 시리즈 시작 날짜 :{" "}
                  {timestampCalculator(sereisData?.start_date, "date")}
                </p>
                <p>
                  대회 시리즈 종료 날짜 :{" "}
                  {timestampCalculator(sereisData?.end_date, "date")}
                </p>
              </Style.SeriesDataDiv>
            )}
          </Style.AreaDiv>
        )}

        {/* 게임 정보 입력 */}
        <Style.AreaDiv>
          <h2>게임 정보 입력</h2>
          <CStyle.GuideDiv>
            <p>
              게임 정보는 사용자 앱에서 출력되는 데이터이자, 듀레이션 타이머의
              자동 계산에 사용됩니다.
            </p>
          </CStyle.GuideDiv>
          <CStyle.GuideDiv>
            <p>
              레지 마감 레벨, 최대 엔트리, 리엔트리 횟수 제한은 입력하지 않을시
              제한 없음으로 동작합니다.
            </p>
            <p>얼리 마감 레벨은 입력하지 않을시 얼리 없음으로 동작합니다.</p>
            <p>
              리엔트리 추가 칩, 얼리 추가 칩, 에드온 추가 칩은 입력하지 않을시
              추가 칩 없음으로 동작합니다.
            </p>
          </CStyle.GuideDiv>
          <CStyle.GuideDiv>
            <p>리엔트리 횟수 제한을 0으로 입력하면 프리즈 아웃이 됩니다.</p>
            <p>
              레지 마감 레벨, 얼리 마감 레벨은 입력한 레벨 전 까지로 동작합니다.
              ( ex. 13 입력시 13 레벨이 되는 순간 중단 )
            </p>
          </CStyle.GuideDiv>
          <ITStyle.TableDiv>
            <ITStyle.TableElement>
              <h2>
                스타팅 칩<span>*</span>
              </h2>
              <input
                ref={startingChipRef}
                placeholder="1이상 숫자"
                defaultValue={eventData?.starting_chip}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>레지 마감 레벨</h2>
              <input
                ref={regEndLevelRef}
                placeholder="1이상 숫자"
                defaultValue={eventData?.reg_end_level}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>얼리 마감 레벨</h2>
              <input
                ref={earlyEndLevelRef}
                placeholder="1이상 숫자"
                defaultValue={eventData?.early_end_level}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>얼리 칩</h2>
              <input
                ref={earlyChipRef}
                placeholder="0이상 숫자"
                defaultValue={eventData?.early_chip}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>에드온 조건</h2>
              <input
                ref={addOnRef}
                placeholder="40글자 이하"
                defaultValue={eventData?.add_on}
                onKeyDown={handleTextOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>에드온 칩</h2>
              <input
                ref={addOnChipRef}
                placeholder="0이상 숫자"
                defaultValue={eventData?.add_on_chip}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableVerticalElement>
              <h2>리엔트리 횟수 제한</h2>
              <input
                ref={reEntryRef}
                placeholder="0이상 숫자"
                defaultValue={eventData?.re_entry}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableVerticalElement>
            <ITStyle.TableVerticalElement>
              <h2>
                리엔트리 칩
                <Style.AddBtn onClick={incReEntryChipEvent}>
                  <img src={addIcon} />
                </Style.AddBtn>
              </h2>
              {reEntryList?.map((elem, index) => (
                <>
                  <input
                    onChange={(e) => changeReEntryChipEvent(e, index)}
                    placeholder="0이상 숫자"
                    defaultValue={elem}
                  />
                  <Style.AddBtn onClick={() => deleteReEntryEvent(index)}>
                    <img src={eraseIcon} />
                  </Style.AddBtn>
                </>
              ))}
            </ITStyle.TableVerticalElement>
            <ITStyle.TableElement>
              <h2>최대 엔트리</h2>
              <input
                ref={maxEntryRef}
                placeholder="1이상 숫자"
                defaultValue={eventData?.max_entry}
                onKeyDown={handleNumbersOnly}
              />
            </ITStyle.TableElement>
            <ITStyle.TableElement>
              <h2>총 프라이즈</h2>
              <input
                ref={prizeTotalRef}
                placeholder="40글자 이하"
                defaultValue={eventData?.prize_total}
              />
            </ITStyle.TableElement>

            {sereisData && eventTypeFlag === OFFICIAL && (
              <>
                <ITStyle.TableElement>
                  <h2>
                    참가 시드권 종류<span>*</span>
                  </h2>
                  <select
                    ref={seeTicketTypeRef}
                    onChange={changeSeedTicketTypeEvent}
                  >
                    <option>== 선택 ==</option>
                    {seedTicketTypeList?.data?.seed_ticket_type?.map((elem) => (
                      <option value={elem?.idx}>{elem?.name}</option>
                    ))}
                  </select>
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                  <h2>
                    참가 시드권 개수<span>*</span>
                  </h2>
                  <input
                    ref={ticketNumberRef}
                    placeholder="1이상 숫자"
                    defaultValue={eventData?.ticket_number}
                    onKeyDown={handleNumbersOnly}
                  />
                </ITStyle.TableElement>
              </>
            )}
            {[STORE, PRELIMINARY].includes(eventTypeFlag) && (
              <ITStyle.TableElement>
                <h2>
                  참가 매장 이용권 개수<span>*</span>
                </h2>
                <input
                  ref={ticketNumberRef}
                  placeholder="1이상 숫자"
                  defaultValue={eventData?.ticket_number}
                  onKeyDown={handleNumbersOnly}
                />
              </ITStyle.TableElement>
            )}
            {eventTypeFlag === FREEROLL && (
              <ITStyle.TableElement>
                <h2>
                  참가권 발행 개수<span>*</span>
                </h2>
                <input
                  ref={publishedTicketNumberRef}
                  placeholder="1이상 숫자"
                  defaultValue={eventData?.published_ticket_number}
                  onKeyDown={handleNumbersOnly}
                />
              </ITStyle.TableElement>
            )}
          </ITStyle.TableDiv>
        </Style.AreaDiv>

        {/* 프라이즈 정보 입력 */}
        <Style.AreaDiv>
          <Style.AreaHeader>
            <h2>
              프라이즈 목록<span>*</span>
            </h2>
            <DefaultButton small fitWidth clickEvent={createPrizeEvent}>
              구간 추가
            </DefaultButton>
          </Style.AreaHeader>
          <CStyle.GuideDiv>
            <p>
              프라이즈는 출력용 데이터이므로 자유로운 양식으로 작성해도 됩니다.
            </p>
          </CStyle.GuideDiv>

          <Style.PrizeTable>
            <Style.TableHeader>
              <Style.RankTd>순위 정보</Style.RankTd>
              <td>프라이즈 정보</td>
              <td></td>
            </Style.TableHeader>
            {prizeList.map((elem, index) => (
              <tr>
                {elem?.map((childElem, childIndex) => (
                  <Style.ElemTd>
                    <input
                      onChange={(e) => setPrize(e, childIndex, index)}
                      value={childElem}
                    />
                  </Style.ElemTd>
                ))}
                <Style.FitTd>
                  <Style.ControlDiv>
                    <button onClick={() => deletePrizeEvent(index)}>
                      <img src={eraseIcon} />
                    </button>
                    <button onClick={() => upperPrizeEvent(index)}>
                      <img src={upperIcon} />
                    </button>
                    <button onClick={() => downPrizeEvent(index)}>
                      <img src={downIcon} />
                    </button>
                  </Style.ControlDiv>
                </Style.FitTd>
              </tr>
            ))}
          </Style.PrizeTable>
        </Style.AreaDiv>

        {/* 듀레이션 정보 입력 */}
        <Style.AreaDiv>
          <Style.AreaHeader>
            <h2>
              듀레이션 목록<span>*</span>
            </h2>
            <div>
              <DefaultButton small fitWidth clickEvent={createDurationEvent}>
                구간 추가
              </DefaultButton>
              <DefaultButton small fitWidth clickEvent={createBreakEvent}>
                브레이크 타임 추가
              </DefaultButton>
            </div>
          </Style.AreaHeader>
          <CStyle.GuideDiv>
            <p>모든 값은 숫자로만 입력해야 합니다.</p>
            <p>
              구간 타임 추가 버튼을 누르면 목록 하단에 영역이 추가되고 값을
              입력할 수 있습니다.
            </p>
            <p>
              브레이크 타임 추가 버튼을 누르면 목록 하단에 브레이크 영역이
              추가되고 Minute만 입력할 수 있습니다.
            </p>
            <p>SB를 입력하면 자동으로 BB와 Ante에 2배 값이 입력됩니다.</p>
            <p>BB를 입력하면 자동으로 Ante에 같은 값이 입력됩니다.</p>
          </CStyle.GuideDiv>

          <Style.PrizeTable>
            <Style.TableHeader>
              <td>Level</td>
              <td>Minute</td>
              <td>SB</td>
              <td>BB</td>
              <td>Ante</td>
              <td></td>
            </Style.TableHeader>
            {durationList.map((elem, index) => {
              if (elem[0] !== "break") levelIndex += 1;
              return (
                <tr>
                  {elem?.map((childElem, childIndex) => (
                    <Style.ElemTd $head={childIndex === 0}>
                      {childElem !== "empty" ? (
                        <input
                          onChange={(e) => setDuration(e, childIndex, index)}
                          value={
                            childIndex === 0 && childElem !== "break"
                              ? `Lv.${levelIndex}`
                              : childElem
                          }
                          readOnly={childIndex === 0}
                        />
                      ) : null}
                    </Style.ElemTd>
                  ))}
                  <Style.FitTd>
                    <Style.ControlDiv>
                      <button onClick={() => deleteDurationEvent(index)}>
                        <img src={eraseIcon} />
                      </button>
                      <button onClick={() => upperDurationEvent(index)}>
                        <img src={upperIcon} />
                      </button>
                      <button onClick={() => downDurationEvent(index)}>
                        <img src={downIcon} />
                      </button>
                    </Style.ControlDiv>
                  </Style.FitTd>
                </tr>
              );
            })}
          </Style.PrizeTable>
        </Style.AreaDiv>
      </Style.Wrapper>
    </>
  );
};

export default EventCreate;
